<template>


  <div>
    <table class="toolTable table" width="100%" cellspacing="0" cellpadding="0" style="width: 1600px;">
      <caption>HTML特殊转义字符对照表</caption>
      <tbody><tr>
        <th class="separateColor">字符</th>
        <th>十进制</th>
        <th>转义字符</th>
        <th class="separateColor">字符</th>
        <th>十进制</th>
        <th>转义字符</th>
        <th class="separateColor">字符</th>
        <th>十进制</th>
        <th>转义字符</th>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#161;</td>
        <td>&amp;iexcl;</td>
        <td class="separateColor">Á</td>
        <td>&amp;#193;</td>
        <td>&amp;Aacute;</td>
        <td class="separateColor">á</td>
        <td>&amp;#225;</td>
        <td>&amp;aacute;</td>
      </tr>
      <tr>
        <td class="separateColor">￠</td>
        <td>&amp;#162;</td>
        <td>&amp;cent;</td>
        <td class="separateColor">Â</td>
        <td>&amp;#194;</td>
        <td>&amp;circ;</td>
        <td class="separateColor">â</td>
        <td>&amp;#226</td>
        <td>&amp;acirc;</td>
      </tr>
      <tr>
        <td class="separateColor">￡</td>
        <td>&amp;#163;</td>
        <td>&amp;pound;</td>
        <td class="separateColor">Ã</td>
        <td>&amp;#195;</td>
        <td>&amp;Atilde;</td>
        <td class="separateColor">ã</td>
        <td>&amp;#227;</td>
        <td>&amp;atilde;</td>
      </tr>
      <tr>
        <td class="separateColor">¤</td>
        <td>&amp;#164;</td>
        <td>&amp;curren;</td>
        <td class="separateColor">Ä</td>
        <td>&amp;#196;</td>
        <td>&amp;Auml</td>
        <td class="separateColor">ä</td>
        <td>&amp;#228;</td>
        <td>&amp;auml;</td>
      </tr>
      <tr>
        <td class="separateColor">￥</td>
        <td>&amp;#165;</td>
        <td>&amp;yen;</td>
        <td class="separateColor">Å</td>
        <td>&amp;#197;</td>
        <td>&amp;ring;</td>
        <td class="separateColor">å</td>
        <td>&amp;#229;</td>
        <td>&amp;aring;</td>
      </tr>
      <tr>
        <td class="separateColor">|</td>
        <td>&amp;#166;</td>
        <td>&amp;brvbar;</td>
        <td class="separateColor">Æ</td>
        <td>&amp;#198;</td>
        <td>&amp;AElig;</td>
        <td class="separateColor">æ</td>
        <td>&amp;#230;</td>
        <td>&amp;aelig;</td>
      </tr>
      <tr>
        <td class="separateColor">§</td>
        <td>&amp;#167;</td>
        <td>&amp;sect;</td>
        <td class="separateColor">Ç</td>
        <td>&amp;#199;</td>
        <td>&amp;Ccedil;</td>
        <td class="separateColor">ç</td>
        <td>&amp;#231;</td>
        <td>&amp;ccedil;</td>
      </tr>
      <tr>
        <td class="separateColor">¨</td>
        <td>&amp;#168;</td>
        <td>&amp;uml;</td>
        <td class="separateColor">È</td>
        <td>&amp;#200;</td>
        <td>&amp;Egrave;</td>
        <td class="separateColor">è</td>
        <td>&amp;#232;</td>
        <td>&amp;egrave;</td>
      </tr>
      <tr>
        <td class="separateColor">©</td>
        <td>&amp;#169;</td>
        <td>&amp;copy;</td>
        <td class="separateColor">É</td>
        <td>&amp;#201;</td>
        <td>&amp;Eacute;</td>
        <td class="separateColor">é</td>
        <td>&amp;#233;</td>
        <td>&amp;eacute;</td>
      </tr>
      <tr>
        <td class="separateColor">a</td>
        <td>&amp;#170;</td>
        <td>&amp;ordf;</td>
        <td class="separateColor">Ê</td>
        <td>&amp;#202;</td>
        <td>&amp;Ecirc;</td>
        <td class="separateColor">ê</td>
        <td>&amp;#234;</td>
        <td>&amp;ecirc;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#171;</td>
        <td>&amp;laquo;</td>
        <td class="separateColor">Ë</td>
        <td>&amp;#203;</td>
        <td>&amp;Euml;</td>
        <td class="separateColor">ë</td>
        <td>&amp;#235;</td>
        <td>&amp;euml;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#172;</td>
        <td>&amp;not;</td>
        <td class="separateColor">Ì</td>
        <td>&amp;#204;</td>
        <td>&amp;Igrave;</td>
        <td class="separateColor">ì</td>
        <td>&amp;#236;</td>
        <td>&amp;igrave;</td>
      </tr>
      <tr>
        <td class="separateColor">/x7f</td>
        <td>&amp;#173;</td>
        <td>&amp;shy;</td>
        <td class="separateColor">Í</td>
        <td>&amp;#205;</td>
        <td>&amp;Iacute;</td>
        <td class="separateColor">í</td>
        <td>&amp;#237;</td>
        <td>&amp;iacute;</td>
      </tr>
      <tr>
        <td class="separateColor">®</td>
        <td>&amp;#174;</td>
        <td>&amp;reg;</td>
        <td class="separateColor">Î</td>
        <td>&amp;#206;</td>
        <td>&amp;Icirc;</td>
        <td class="separateColor">î</td>
        <td>&amp;#238;</td>
        <td>&amp;icirc;</td>
      </tr>
      <tr>
        <td class="separateColor">ˉ</td>
        <td>&amp;#175;</td>
        <td>&amp;macr;</td>
        <td class="separateColor">Ï</td>
        <td>&amp;#207;</td>
        <td>&amp;Iuml;</td>
        <td class="separateColor">ï</td>
        <td>&amp;#239;</td>
        <td>&amp;iuml;</td>
      </tr>
      <tr>
        <td class="separateColor">°</td>
        <td>&amp;#176;</td>
        <td>&amp;deg;</td>
        <td class="separateColor">Ð</td>
        <td>&amp;#208;</td>
        <td>&amp;ETH;</td>
        <td class="separateColor">ð</td>
        <td>&amp;#240;</td>
        <td>&amp;ieth;</td>
      </tr>
      <tr>
        <td class="separateColor">±</td>
        <td>&amp;#177;</td>
        <td>&amp;plusmn;</td>
        <td class="separateColor">Ñ</td>
        <td>&amp;#209;</td>
        <td>&amp;Ntilde;</td>
        <td class="separateColor">ñ</td>
        <td>&amp;#241;</td>
        <td>&amp;ntilde;</td>
      </tr>
      <tr>
        <td class="separateColor">2</td>
        <td>&amp;#178;</td>
        <td>&amp;sup2;</td>
        <td class="separateColor">Ò</td>
        <td>&amp;#210;</td>
        <td>&amp;Ograve;</td>
        <td class="separateColor">ò</td>
        <td>&amp;#242;</td>
        <td>&amp;ograve;</td>
      </tr>
      <tr>
        <td class="separateColor">3</td>
        <td>&amp;#179;</td>
        <td>&amp;sup3;</td>
        <td class="separateColor">Ó</td>
        <td>&amp;#211;</td>
        <td>&amp;Oacute;</td>
        <td class="separateColor">ó</td>
        <td>&amp;#243;</td>
        <td>&amp;oacute;</td>
      </tr>
      <tr>
        <td class="separateColor">′</td>
        <td>&amp;#180;</td>
        <td>&amp;acute;</td>
        <td class="separateColor">Ô</td>
        <td>&amp;#212;</td>
        <td>&amp;Ocirc;</td>
        <td class="separateColor">ô</td>
        <td>&amp;#244;</td>
        <td>&amp;ocirc;</td>
      </tr>
      <tr>
        <td class="separateColor">μ</td>
        <td>&amp;#181;</td>
        <td>&amp;micro;</td>
        <td class="separateColor">Õ</td>
        <td>&amp;#213;</td>
        <td>&amp;Otilde;</td>
        <td class="separateColor">õ</td>
        <td>&amp;#245;</td>
        <td>&amp;otilde;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#182;</td>
        <td>&amp;para;</td>
        <td class="separateColor">Ö</td>
        <td>&amp;#214;</td>
        <td>&amp;Ouml;</td>
        <td class="separateColor">ö</td>
        <td>&amp;#246;</td>
        <td>&amp;ouml;</td>
      </tr>
      <tr>
        <td class="separateColor">·</td>
        <td>&amp;#183;</td>
        <td>&amp;middot;</td>
        <td class="separateColor">&amp;times;</td>
        <td>&amp;#215;</td>
        <td>&amp;times;</td>
        <td class="separateColor">÷</td>
        <td>&amp;#247;</td>
        <td>&amp;divide;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#184;</td>
        <td>&amp;cedil;</td>
        <td class="separateColor">Ø</td>
        <td>&amp;#216;</td>
        <td>&amp;Oslash;</td>
        <td class="separateColor">ø</td>
        <td>&amp;#248;</td>
        <td>&amp;oslash;</td>
      </tr>
      <tr>
        <td class="separateColor">1</td>
        <td>&amp;#185;</td>
        <td>&amp;sup1;</td>
        <td class="separateColor">Ù</td>
        <td>&amp;#217;</td>
        <td>&amp;Ugrave;</td>
        <td class="separateColor">ù</td>
        <td>&amp;#249;</td>
        <td>&amp;ugrave;</td>
      </tr>
      <tr>
        <td class="separateColor">o</td>
        <td>&amp;#186;</td>
        <td>&amp;ordm;</td>
        <td class="separateColor">Ú</td>
        <td>&amp;#218;</td>
        <td>&amp;Uacute;</td>
        <td class="separateColor">ú</td>
        <td>&amp;#250;</td>
        <td>&amp;uacute;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#187;</td>
        <td>&amp;raquo;</td>
        <td class="separateColor">Û</td>
        <td>&amp;#219;</td>
        <td>&amp;Ucirc;</td>
        <td class="separateColor">û</td>
        <td>&amp;#251;</td>
        <td>&amp;ucirc;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#188;</td>
        <td>&amp;frac14;</td>
        <td class="separateColor">Ü</td>
        <td>&amp;#220;</td>
        <td>&amp;Uuml;</td>
        <td class="separateColor">ü</td>
        <td>&amp;#252;</td>
        <td>&amp;uuml;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#189;</td>
        <td>&amp;frac12;</td>
        <td class="separateColor">Ý</td>
        <td>&amp;#221;</td>
        <td>&amp;Yacute;</td>
        <td class="separateColor">ý</td>
        <td>&amp;#253;</td>
        <td>&amp;yacute;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#190;</td>
        <td>&amp;frac34;</td>
        <td class="separateColor">Þ</td>
        <td>&amp;#222;</td>
        <td>&amp;THORN;</td>
        <td class="separateColor">þ</td>
        <td>&amp;#254;</td>
        <td>&amp;thorn;</td>
      </tr>
      <tr>
        <td class="separateColor">?</td>
        <td>&amp;#191;</td>
        <td>&amp;iquest;</td>
        <td class="separateColor">ß</td>
        <td>&amp;#223;</td>
        <td>&amp;szlig;</td>
        <td class="separateColor">ÿ</td>
        <td>&amp;#255;</td>
        <td>&amp;yuml;</td>
      </tr>
      <tr>
        <td class="separateColor">À</td>
        <td>&amp;#192;</td>
        <td>&amp;Agrave;</td>
        <td class="separateColor">à</td>
        <td>&amp;#224;</td>
        <td>&amp;agrave;</td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
export default {
  name: "HtmlTransfer"
}
</script>

<style scoped>
/* 添加圆角和边框 */
.toolTable {
  border-radius: 10px;
  border: 2px solid #4154F1;
}

/* 添加简洁的间距 */
.toolTable th,
.toolTable td {
  padding: 15px;
  text-align: left;
}

/* 添加跨列的表头 */
.toolTable th {
  background-color: #4154F1;
  color: white;
}

/* 使用现代的字体样式 */
.toolTable th,
.toolTable td {
  font-family: Arial, sans-serif;
}

/* 添加鼠标悬停时的样式 */
.toolTable tr:hover {
  background-color: #f5f5f5;
}
</style>
